import { isCvoProductServiceName, selectCvoProductContext } from "../../../utils/cvoMarketplaceUtils";

const defaultState = {
    error: null,
    row: null,
    liveState: null,
    isLoading: false
};

const marketplaceContextReducer = (state = defaultState, { type, payload }) => {
    switch (type) {
        case "MARKETPLACE-CONTEXT:FETCH-PENDING":
            return { ...state, isLoading: true };

        case "MARKETPLACE-CONTEXT:FETCH-SUCCESS": {
            // handleApiAction wraps the response in payload.data
            const data = payload?.data || payload;
            // Backend returns { contexts: [{ row, liveState }] }. Scope to the standalone CVO product
            // context so a different product's context never drives our CVO resume flow.
            // Falls back to the legacy single-object shape for safety.
            const contexts = data?.contexts || [];
            const cvoContext = selectCvoProductContext(contexts)
                || (data?.row && isCvoProductServiceName(data?.row?.serviceName)
                    ? { row: data.row, liveState: data.liveState }
                    : null);
            return {
                ...state,
                isLoading: false,
                row: cvoContext?.row ?? null,
                liveState: cvoContext?.liveState ?? null,
                error: null
            };
        }
        case "MARKETPLACE-CONTEXT:FETCH-ERROR":
            return { ...state, isLoading: false, error: payload };

        // SAVE (POST) lifecycle — response is { written: true } or { skipped: true }.
        // row/liveState are not in the POST response; the middleware chains a FETCH after
        // success to populate them.
        case "MARKETPLACE-CONTEXT:SAVE-PENDING":
            return { ...state, error: null };

        case "MARKETPLACE-CONTEXT:SAVE-SUCCESS":
            return { ...state, error: null };

        case "MARKETPLACE-CONTEXT:SAVE-ERROR":
            return { ...state, error: payload };

        case "MARKETPLACE-CONTEXT:CLEAR-SUCCESS":
            return { ...defaultState, isLoading: false };

        case "MARKETPLACE-CONTEXT:CLEAR-ERROR":
            return { ...state, isLoading: false, error: payload };

        default:
            return state;
    }
};

export default marketplaceContextReducer;
